/* Mint-HR · Tổng quan. Màu chỉ var(--…); số đo theo board (CW 1240, thẻ r16, padding 16/18, hàng 48). */
.page { display: flex; flex-direction: column; gap: 14px; padding: 2px 0 24px; min-width: 0; }
.tabs { display: flex; min-width: 0; }
.warn { color: var(--warn); }
.mute { color: var(--lb); }
.right { text-align: right !important; }

.kpis { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; }
.kpisOv { margin-top: 4px; }
.kpi { padding: 16px 20px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.kpiK { color: var(--lb); font-size: 13px; }
.kpiV { display: flex; align-items: baseline; gap: 8px; margin-top: 4px; }
.kpiV b { font-size: 28px; font-weight: var(--fw-label); letter-spacing: -0.03em; }
.kpiV span { font-size: 12px; color: var(--lb); }

.grid { display: grid; grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr); gap: 14px; align-items: start; }
.col { display: flex; flex-direction: column; gap: 14px; min-width: 0; }
.card { border-radius: 16px; background: var(--card); box-shadow: var(--sh); padding: 16px 18px; overflow: clip; font-size: 13px; }
.cardHd { display: flex; justify-content: space-between; align-items: baseline; }
.cardHd h2 { margin: 0; font-size: 16px; font-weight: var(--fw-title); }
.cardHd > span { color: var(--lb); font-size: 13px; }
section.card:has(> .table) { padding: 0; }

.ev { display: flex; align-items: center; gap: 12px; min-height: 53px; border-top: 1px solid var(--line); }
.cardHd + .ev { margin-top: 6px; }
.evDone { opacity: 0.55; }
.evKind { width: 92px; flex-shrink: 0; padding: 3px 0; border-radius: 8px; text-align: center; font-size: 12px; font-weight: var(--fw-title); }
.tWarn { background: var(--warn-bg); color: var(--warn); }
.tPri { background: var(--pri-bg); color: var(--link); }
.tOk { background: var(--ok-bg); color: var(--ok); }
.tMute { background: var(--sub); color: var(--tx2); }
.evTx { flex: 1; min-width: 0; }
.evTx b { font-weight: var(--fw-label); }
.evTx div { font-size: 12px; color: var(--lb); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.evDue { width: 96px; flex-shrink: 0; font-size: 12px; font-weight: var(--fw-label); color: var(--tx2); }
.evDue.warn { color: var(--warn); }
.evAct { display: inline-flex; align-items: center; gap: 6px; height: 32px; padding: 0 12px; border: 0; border-radius: 9px; background: var(--pri-bg); color: var(--link); font: inherit; font-weight: var(--fw-label); white-space: nowrap; cursor: pointer; }
.evOk { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; padding: 0; border: 1px solid var(--bd); border-radius: 9px; background: var(--card); color: var(--tx2); cursor: pointer; }
.evClosed { display: inline-flex; align-items: center; gap: 4px; font-size: 12px; font-weight: var(--fw-label); color: var(--ok); }
.evAct:focus-visible, .evOk:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
@media (hover: hover) { .evAct:hover { background: var(--pri-bd); } .evOk:hover { background: var(--ctl); } }

.legend { display: flex; gap: 12px; font-size: 12px; color: var(--lb); }
.legend span { display: inline-flex; align-items: center; gap: 5px; }
.legend i { display: inline-block; }
.lgLine { width: 14px; height: 3px; border-radius: 2px; background: var(--d-blue); }
.lgIn, .lgOut { width: 8px; height: 8px; border-radius: 2px; }
.lgIn { background: var(--d-green); }
.lgOut { background: var(--d-amber); }
.chart { display: block; margin-top: 8px; overflow: visible; }
.axis { stroke: var(--bd); }
.area { fill: var(--d-blue); opacity: 0.08; }
.line { fill: none; stroke: var(--d-blue); stroke-width: 3; stroke-linecap: round; stroke-linejoin: round; }
.dot { fill: var(--card); stroke: var(--d-blue); stroke-width: 2.5; }
.pv { font-size: 12px; font-weight: var(--fw-label); fill: var(--tx); font-family: inherit; }
.pm { font-size: 12px; fill: var(--lb); font-family: inherit; }
.mov { display: block; margin-top: 2px; }
.bIn { fill: var(--d-green); }
.bOut { fill: var(--d-amber); }
.note { margin-top: 6px; font-size: 12px; color: var(--lb); }

.bars { display: flex; align-items: flex-end; gap: 6px; height: 120px; margin-top: 12px; }
.bar { flex: 1 1 0; display: flex; flex-direction: column; align-items: center; justify-content: flex-end; gap: 4px; height: 100%; }
.bar span { font-size: 12px; color: var(--tx2); }
.bar .barK { color: var(--lb); }
.bar div { width: 100%; border-radius: 4px 4px 0 0; background: var(--d-blue); }
.bar div.barNow { background: var(--pri); }
.sec { margin-top: 12px; font-weight: var(--fw-label); }
.top { display: grid; grid-template-columns: 110px minmax(0, 1fr) 70px; gap: 10px; align-items: center; min-height: 30px; }
.topV { text-align: right; font-size: 12px; color: var(--tx2); }
.track { height: 8px; border-radius: 4px; background: var(--line); overflow: hidden; }
.track > div { height: 100%; border-radius: 4px; background: var(--d-blue); }
.track > .violet { background: var(--d-violet); }
.track > .amber { background: var(--d-amber); }

.mix { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; margin-top: 10px; }
.mixK { font-size: 12px; color: var(--lb); margin-bottom: 6px; }
.mixRow { display: grid; gap: 8px; align-items: center; min-height: 26px; }
.mixRow.g { grid-template-columns: 44px minmax(0, 1fr) 40px; }
.mixRow.a { grid-template-columns: 52px minmax(0, 1fr) 32px; }
.mixRow b { text-align: right; font-weight: var(--fw-label); }

.table { width: 100%; table-layout: fixed; border-collapse: collapse; white-space: nowrap; }
.table th { box-sizing: border-box; height: 42px; padding: 0 14px; font-size: 12px; font-weight: 500; color: var(--lb); text-align: left; border-bottom: 1px solid var(--line); }
.table td { height: 49px; padding: 0 14px; border-bottom: 1px solid var(--line); }
.dn { font-weight: var(--fw-label); }
.fill { display: flex; align-items: center; gap: 10px; }
.fillBar { flex: 1; min-width: 0; }
.fillN { width: 46px; text-align: right; }
.fillN b { font-weight: var(--fw-label); }
.fillN span { color: var(--lb); }
.warnB { font-weight: var(--fw-label); color: var(--warn); }
.noteTd { color: var(--tx2); overflow: hidden; text-overflow: ellipsis; }

/* Tab Nhân sự (board Mint-HR khối staff*): thanh lọc 40, bảng 7 cột, thẻ 4 cột. */
.sfBar { display: flex; gap: 10px; align-items: center; }
.sfSearch { display: flex; align-items: center; gap: 10px; width: 240px; height: 40px; padding: 0 14px; box-sizing: border-box; border-radius: 12px; background: var(--card); box-shadow: var(--sh); color: var(--lb); }
.sfSearch input { flex: 1; min-width: 0; border: 0; outline: 0; background: transparent; font: inherit; color: var(--tx); }
.sfSearch:focus-within { outline: 2px solid var(--pri); outline-offset: 2px; }
.sfPopWrap { position: relative; }
.sfBtn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; height: 40px; padding: 0 14px; border: 0; border-radius: 12px; background: var(--ctl); color: var(--tx2); font: inherit; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.sfBtnOn { background: var(--pri-bg); color: var(--link); }
.sfBtn:focus-visible, .sfClear:focus-visible, .sfRow:focus-visible, .sfCard:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.sfScrim { position: fixed; inset: 0; z-index: 15; }
.sfPop { position: absolute; left: 0; top: calc(100% + 6px); z-index: 30; width: 300px; padding: 14px; box-sizing: border-box; border-radius: 14px; background: var(--card); box-shadow: var(--pop); display: flex; flex-direction: column; gap: 10px; }
.sfField { display: block; }
.sfField div { font-size: 12px; font-weight: var(--fw-label); color: var(--tx2); margin-bottom: 4px; }
.sfField select { width: 100%; height: 36px; padding: 0 8px; border-radius: 9px; border: 1px solid var(--bd); background: var(--card); color: var(--tx); font: inherit; }
.sfFoot { display: flex; justify-content: space-between; align-items: center; }
.sfFoot > span { font-size: 12px; color: var(--lb); }
.sfClear { display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 10px; border: 0; border-radius: 8px; background: transparent; color: var(--link); font: inherit; font-weight: var(--fw-label); cursor: pointer; }
.sfCount { margin-left: auto; color: var(--lb); white-space: nowrap; }
.sfWho { display: flex; align-items: center; gap: 10px; min-width: 0; text-align: left; }
.sfWho b { display: block; font-weight: var(--fw-label); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sfWho span:not([aria-hidden]) { font-size: 12px; color: var(--lb); }
.sfAv, .sfAv30 { flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: var(--ctl); font-weight: var(--fw-title); }
.sfAv { width: 40px; height: 40px; border-radius: 12px; font-size: 13px; }
.sfAv30 { width: 30px; height: 30px; border-radius: 9px; font-size: 11px; }
.sfChips { display: flex; gap: 4px; flex-wrap: nowrap; }
.seatChip { padding: 2px 8px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); }
.stChip { display: inline-flex; align-items: center; gap: 6px; padding: 3px 10px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); }
.stChip i { width: 7px; height: 7px; border-radius: 50%; }
.dOk { background: var(--ok); }
.dWarn { background: var(--warn); }
.dPri { background: var(--pri); }
.sfRow { cursor: pointer; }
@media (hover: hover) { .sfRow:hover { background: var(--sub); } .sfBtn:hover { background: var(--pri-bg); } }
.sfCards { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
.sfCard { padding: 14px 16px; border: 0; border-radius: 16px; background: var(--card); box-shadow: var(--sh); color: var(--tx); font: inherit; display: flex; flex-direction: column; gap: 8px; cursor: pointer; text-align: left; }
.sfCard .sfChips { flex-wrap: wrap; }
.sfMeta { font-size: 12px; color: var(--tx2); }

.orgBar { display: flex; gap: 10px; align-items: center; }
.orgBar .grow { flex-grow: 1; }

/* Cơ cấu & ghế › Danh sách (Phòng ban / Chức danh / Bậc) + JD (board khối orgList, orgJd). */
.olCell { overflow: hidden; text-overflow: ellipsis; }
.olLink { color: var(--link); }
.olAct { display: flex; gap: 6px; justify-content: flex-end; }
.olEdit, .olDel { display: inline-flex; align-items: center; justify-content: center; gap: 6px; height: 30px; border: 0; border-radius: 8px; font: inherit; font-size: 12px; font-weight: var(--fw-label); white-space: nowrap; cursor: pointer; }
.olEdit { padding: 0 12px; background: var(--pri-bg); color: var(--link); }
.olDel { padding: 0 10px; border: 1px solid var(--bd); background: var(--card); color: var(--lb); }
.olDelErr { color: var(--err); }
.olEdit:focus-visible, .olDel:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.olNote { padding: 10px 18px; font-size: 12px; color: var(--tx2); background: var(--sub); }
.jd { display: flex; flex-direction: column; gap: 12px; padding: 16px 18px; }
.jdTop { display: flex; gap: 10px; align-items: flex-end; flex-wrap: wrap; }
.jdTitle { display: block; width: 320px; }
.jdLbl, .jdTitle div, .jdField div { font-size: 12px; font-weight: var(--fw-label); color: var(--tx2); margin-bottom: 6px; }
.jdTitle select { width: 100%; height: 40px; padding: 0 10px; border-radius: 10px; border: 1px solid var(--bd); background: var(--card); color: var(--tx); font: inherit; }
.jdVer { margin-left: auto; font-size: 12px; color: var(--lb); }
.jdField { display: block; }
.jdField textarea { width: 100%; box-sizing: border-box; padding: 10px 12px; border-radius: 10px; border: 1px solid var(--bd); background: var(--card); color: var(--tx); font: inherit; line-height: 1.5; resize: vertical; }
.jdFoot { display: flex; align-items: center; gap: 8px; }
.jdFoot > span:first-child { font-size: 12px; color: var(--lb); }
.jdFoot .grow { flex-grow: 1; }
.orgBar .olAdd { border: 0; background: var(--pri-bg); color: var(--link); }
.jdFoot .jdSaveOff { background: var(--lb); }

/* Mint-LaborContract · Tổng quan: 2 cột (1fr + 400), hàng việc 56, vòng đời hàng 36 */
.cGrid { display: grid; grid-template-columns: minmax(0, 1fr) 400px; gap: 14px; align-items: start; }
.cTodo { display: grid; grid-template-columns: 120px minmax(0, 1fr) auto; gap: 12px; align-items: center; min-height: 56px; border-top: 1px solid var(--line); }
.cTodo .evKind { width: auto; justify-self: start; padding: 2px 9px; border-radius: 999px; white-space: nowrap; }
.tErr { background: var(--err-bg); color: var(--err); }
.cLife { display: flex; gap: 10px; align-items: center; min-height: 36px; border-top: 1px solid var(--line); }
.cLife:first-of-type { border-top: 0; }
.cLife > i { width: 22px; height: 22px; flex-shrink: 0; border-radius: 50%; background: var(--pri-bg); color: var(--link); display: flex; align-items: center; justify-content: center; font: inherit; font-size: 12px; font-weight: var(--fw-title); font-style: normal; }
.cLife > span { margin-left: auto; font-weight: var(--fw-label); }
.cLife b, .cRule b { font-weight: var(--fw-label); }
.cLife div div, .cRule div { font-size: 12px; color: var(--lb); }
.cRule { padding: 8px 0; border-top: 1px solid var(--line); }
.cRule div { color: var(--tx2); }
.cCol { display: flex; flex-direction: column; gap: 14px; }
.cCol .cardHd + .cLife, .cCol .cardHd + .cRule { margin-top: 6px; }
.cCol .cardHd + .cLife, .cCol .cardHd + .cRule { border-top: 0; }
